/** @file previewLoader: the editor's PreviewLoader (server export zip, or a local build of the document). */
import { loadPuppetBundle } from '@zilo/pose3d-runtime-babylon/bundle/loadPuppetBundle';
import type { PreviewLoader } from '../state/editorTypes';
import { buildDocPreview } from './buildDocPreview';
import { memoryFetchBytes } from './memoryFetchBytes';
import { placeholderTiles } from './placeholderTiles';
import { unzipBundle } from './unzipBundle';

/** The fake origin the in-memory bundle is served from. */
const BASE = 'mem:/';

/**
 * `zip`: `unzipBundle` then the runtime's `loadPuppetBundle('mem:/manifest.json', memoryFetchBytes(files))`; `doc`:
 * `buildDocPreview` (export's `buildBundle`) then the same loader, with export's warnings ahead of the check's.
 * Either way every unpainted tile gets a placeholder box (`placeholderTiles`), so empty parts show and can be picked.
 */
export const previewLoader: PreviewLoader = async (source) => {
  if (source.kind === 'zip') return placeholderTiles(await loadPuppetBundle(`${BASE}manifest.json`, memoryFetchBytes(unzipBundle(source.bytes), BASE)));
  const built = await buildDocPreview(source.doc, source.images);
  const loaded = await loadPuppetBundle(`${BASE}manifest.json`, memoryFetchBytes(built.files, BASE));
  return placeholderTiles({ ...loaded, warnings: [...built.warnings, ...loaded.warnings] });
};
